export default __webpack_public_path__ + "static/media/politica_qualita.1034fec7.jpg";